import * as z from "zod/v4";

export const createShipStationApiIntegration = {
  name: "createShipStationApiIntegration" as const,
  input: z.object({ apiKey: z.string() }),
  output: z.object({ integrationId: z.string() }),
};
